var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    enableBackground: "new 0 0 31 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#178FEB",
    cx: 12.9,
    cy: 12,
    r: 7
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#178FEB",
    d: "M12.7,29.1c-3,0-5.9-0.8-8.7-2.3l2.8-5.3c2.1,1.1,4.2,1.6,6.4,1.5c1.9-0.1,3.9-0.7,5.7-1.7l3,5.2 c-2.7,1.5-5.5,2.4-8.4,2.5C13.2,29.1,12.9,29.1,12.7,29.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#178FEB",
    d: "M22.9,5.6c-0.7,0-1.4,0.1-1.9,0.4c2.1,1.6,3.4,4.1,3.3,6.9c0,0.3,0,0.6-0.1,0.9c1.7-0.6,2.9-2.1,2.9-3.9 C27.2,7.6,25.3,5.7,22.9,5.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#178FEB",
    d: "M26.5,14.9c-0.8,0.4-1.7,0.6-2.6,0.8c-0.4,1.5-1.1,2.8-2.2,3.9c0.4,0,0.8,0,1.2,0c0.1,0,0.3,0,0.4,0 c1.6-0.2,3.2-0.6,4.6-1.2L26.5,14.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarGroup);
export default __webpack_public_path__ + "static/media/avatar-group.770ca36a175367b658d31622fa799b9e.svg";
export { ForwardRef as ReactComponent };